<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="`transaction/invoice-fee-v2`"
			>
				<!-- Product Name -->
				<div class="form-group row align-items-center">
					<label for="input_product_id" class="col-sm-3 mb-0">
						Fee
					</label>
					<app-input
						id="input_product_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_product_id"
						@input="setProductIdValue"
						fetch-url="master/product?is_active=true&product_category=2"
						placeholder="Product Name"
						list-value-field="name"
						:required="true"
					/>
				</div>
				<!-- Quantity -->
				<div class="form-group row align-items-center">
					<label for="inputs_qty" class="col-sm-3 mb-0">
						Quantity
					</label>
					<app-input
						id="inputs_qty"
						class="col-sm-9"
						type="number"
						v-model="inputs.qty"
						placeholder="Quantity"
						:required="true"
					/>
				</div>
				<!-- Unit Price -->
				<div class="form-group row align-items-center">
					<label for="inputs_price" class="col-sm-3 mb-0">
						Unit Price
					</label>
					<app-input
						id="inputs_price"
						class="col-sm-9"
						type="currency-right"
						v-model="formattedPriceDisplay"
						placeholder="Unit Price"
						:required="true"
						disabled
					/>
				</div>
				<!-- Balance -->
				<div class="form-group row align-items-center">
					<label for="inputs_amount" class="col-sm-3 mb-0">
						Balance
					</label>
					<app-input
						id="inputs_amount"
						class="col-sm-9"
						type="currency-right"
						v-model="formattedAmount"
						placeholder="Balance"
						:required="true"
						disabled
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "FeesNoticeDetailsChargesTableForm",
	inject: ["eventHub"],
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		invoiceRequestId: {
			type: Number,
		},
		value: {
			type: Object,
			default: () => {
				return {
					product_category_id: undefined,
					code: "",
					name: "",
					is_active: "",
					product_category: {
						id: undefined,
						code: "",
						name: "",
						is_active: "",
					},
					center_id: {
						id: undefined,
						name: "",
						is_active: "",
					},
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			inputs: {
				invoice_id: this.invoiceRequestId,
				product_id: "",
				qty: 1,
				price: "",
				amount: "",
				is_deduction: false,
			},
			input_product_id: this.value
				? this.value.product
					? {
							id: this.value.product.id || 0,
							name: this.value.product.name || "",
							code: this.value.product.code,
							is_active: this.value.product.is_active,
					  }
					: {
							id: this.value.product?.id || 0,
							name: this.value.product?.name || "",
							code: this.value.product?.code,
							is_active: this.value.product?.is_active,
					  }
				: {
						id: this.value.product.id || 0,
						name: this.value.product.name || "",
						code: this.value.product.code,
						is_active: this.value.product.is_active,
				  },
			modalId: this.formId,
			modalTitle: this.$t("add"),
			productIdLists: [],
			formattedPrice: "",
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}

		this.fetchData();
	},
	methods: {
		async fetchData() {
			try {
				if (this.selectedUrl) {
					this.modalTitle = this.$t("edit");
					this.preloader = true;
				}

				let [productIdResponse] =
					await Promise.all([
						axios.get(
							`/transaction/invoice-item-v2?invoice_id=${this.invoiceRequestId}`
						),
						axios.get(
							"/master/product?is_active=true&product_type=2&per_page=50"
						),
					]);

				productIdResponse.data.data.forEach((item) => {
					this.productIdLists.push({
						id: item.id,
						value: item.name,
					});
				});

			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
			this.eventHub.$emit("studentFeesNoticeDetailsChargesChanged");
		},

		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			this.preloader = false;
		},
		setProductIdValue(data) {
			this.inputs.product_id = this.inputs.product_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.product_id = data.id;
				this.inputs.price = data.price;
			}
		},
	},
	computed: {
		calculatedAmount() {
			return this.inputs.qty * this.inputs.price;
		},
		formattedAmount() {
			return new Intl.NumberFormat("id-ID", {
				style: "currency",
				currency: "IDR",
				minimumFractionDigits: 0,
			}).format(this.inputs.amount);
		},
		formattedPriceDisplay() {
			return new Intl.NumberFormat("id-ID", {
				style: "currency",
				currency: "IDR",
				minimumFractionDigits: 0,
			}).format(this.inputs.price);
		},
	},
	watch: {
		calculatedAmount(newAmount) {
			this.inputs.amount = newAmount;
		},
		"inputs.price": function (newVal) {
			this.formattedPrice = new Intl.NumberFormat("id-ID", {
				style: "currency",
				currency: "IDR",
				minimumFractionDigits: 0,
			}).format(newVal);
		},
	},
};
</script>
